__turbopack_context__.v({
  "className": "ivyoratext_9d86fd69-module__Zos2qa__className",
  "variable": "ivyoratext_9d86fd69-module__Zos2qa__variable",
});
